import React from 'react';

const SectionSeperator = () =>
  <hr className="b--none bg-light-gray ma0 pa0" style={{ height: '2px' }} />;

export default SectionSeperator;



// WEBPACK FOOTER //
// ./src/components/ModerationCard/SectionSeparator.js